/* eslint-disable import/named */
import { createContext } from 'react';
import { KeyedMutator } from 'swr';

type UserContext = {
  id?: number | undefined;
  uuid?: string;
  name?: string;
  email?: string;
  deleted_at?: string | null;
  school_role?: number | null;
  tournament_role?: number | null;
  tournamentIds?: number[];
  mutateCurrentUser: KeyedMutator<any>;
};

const UserContext = createContext<UserContext>({
  id: undefined,
  uuid: '',
  name: '',
  email: '',
  deleted_at: null,
  mutateCurrentUser: async () => {},
});

export default UserContext;
